<template>
    <div>
    <div id="SubPgBody"><!--PGBODY-->
        <div id="SubPgBodyLeft" class="left"><img src="../../assets/images/biaozhi.jpg" width="204" height="188"></div>
        <div id="SubPgBodyRight" class="left">
            <h3>当前位置为：<span id="lanmu">院庆征文</span></h3>
            <p><br>
            </p>
            <ul>

            <li v-for="(item,i) in news_list" :key="i">
                <span class="songti">·</span>
                <router-link :to="'/fifty-news-detail/'+item.id">{{item.title}}&nbsp;&nbsp;({{item.year}}-{{item.month}}-{{item.day}})</router-link>
            </li>

            <div class="clearBoth"></div>
        </ul>
            <p></p>
        </div>
        <div class="clearBoth"></div>
    </div><!--/PGBODY-->
    <div id="BottomSpacer" class="clearBoth"></div>
    </div>
</template>

<script>
    export default {
        name: "NewsList",
        data(){
            return {
                news_list:[]
            }
        },
        created (){
            let cat_id = parseInt(this.$route.params.cat_id);

            this.getList(cat_id)
        },
        methods:{
            async getList(cat_id){
                let that = this;
                that.$http.get(this.$api.getCatList.url,{cat_id:cat_id}).then(result => {
                     console.log(result);
                     that.news_list = result.data.news_list.data;
                });
            }
        },
    }
</script>

<style scoped>

</style>